import { cx } from "class-variance-authority";
import React, { MutableRefObject } from "react";
import { FiChevronDown } from "react-icons/fi";
import { invalidInputOutlineClasses } from "../../input-general/validation";

interface BasicTriggerProps {
  displayLabel: string;
  placeholder?: string;
  validation?: boolean;
  disabled?: boolean;
}

const Base = React.forwardRef((props: BasicTriggerProps, ref) => {
  const isPlaceholder = props.displayLabel === "" || !props.displayLabel;
  const disabled = props.disabled || false;
  return (
    <div
      role="button"
      tabIndex={0}
      className={cx(
        "flex  items-center justify-between space-x-1 rounded border border-dublin-gray bg-white px-4 py-2 text-base focus:outline-none focus:ring-1",
        props.placeholder && !props.displayLabel && "text-macbook",
        props.validation && invalidInputOutlineClasses,
        disabled
          ? "pointer-events-none cursor-not-allowed opacity-60"
          : "focus:border-flo-magenta focus:ring-flo-magenta",
      )}
      ref={ref as MutableRefObject<HTMLDivElement>}
    >
      <span className={"truncate"}>
        {isPlaceholder ? props.placeholder : props.displayLabel}
      </span>
      <span>
        <FiChevronDown size={20} />
      </span>
    </div>
  );
});

export const BasicSelectTriggerForVirtualizedSelect = (
  props: BasicTriggerProps,
) => {
  return <Base {...props} />;
};
